import { useCallback, useEffect, useState } from 'react';
import {
  getStoredTheme,
  initTheme,
  setStoredTheme,
  toggleTheme,
  type ThemeMode,
} from '@lighthouse/shared';

export function useTheme() {
  const [theme, setTheme] = useState<ThemeMode>(() => getStoredTheme());

  useEffect(() => {
    setTheme(initTheme());
  }, []);

  const setMode = useCallback((mode: ThemeMode) => {
    setStoredTheme(mode);
    setTheme(mode);
  }, []);

  const toggle = useCallback(() => {
    setTheme((current) => toggleTheme(current));
  }, []);

  return { theme, setMode, toggle, isDark: theme === 'dark' };
}
